export class ProductosPeriodosGraciasOtrosConceptos {
  id: number;
  idProductoPeriodoGraciaOtroConcepto: string;
  idProductoPeriodoGracia: string;
  idConceptoFacturacion: string;
  indicadorHabilitado: boolean;
  auditoriaUsuario: string;
  auditoriaFecha: Date;
  /*TRANSIENTS*/
  nombreItemConceptos: string;
}
